import React, { useCallback, useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
interface Testimonial {
  id: number;
  name: string;
  avatar: string;
  rating: number;
  text: string;
}
const AVATAR_COLORS = ['bg-[#1a2e1c]', 'bg-[#d8a34d]', 'bg-[#2d4a30]', 'bg-[#8b6914]', 'bg-[#1a2e1c]', 'bg-[#d8a34d]', 'bg-[#2d4a30]', 'bg-[#8b6914]', 'bg-[#1a2e1c]', 'bg-[#d8a34d]'];
const getInitials = (name: string) => {
  const parts = name.replace(/&/g, '').split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return parts[0][0].toUpperCase();
};
const testimonials: Testimonial[] = [{
  id: 1,
  name: 'Neil R Sangani',
  avatar: 'https://lh3.googleusercontent.com/a-/ALV-UjUpZ3cIpoCX8U_ndjVrGalpnn5TcLE1ir6S6__Qcfca9vaBVDUm=w90-h90-p-rp-mo-br100',
  rating: 5,
  text: "As an overseas investor, I spent a long time researching whether investing in the Dubai real estate market was the right decision. I had already done extensive due diligence before coming across Naina and Ikigai Real Estate. From the very beginning, my experience was seamless, transparent, and professional. Naina took the time to understand my goals, addressed my concerns with detailed market insights and honest guidance, and managed the entire process remotely with clarity and efficiency. What stood out most was her advisory approach, she prioritized the right investment fit over quick sales, reassessed options when needed, and consistently acted in my best interest. Everything was structured and stress-free, from start to finish. I would confidently recommend Naina and Ikigai Real Estate to any international investor like me seeking a trusted, long-term partner in Dubai's property market."
}, {
  id: 2,
  name: 'Amber Kazmi',
  avatar: 'https://lh3.googleusercontent.com/a-/ALV-UjX08VupEcYIpnqbCypdOxfhDQqz9m5FPGwJY1c79MljwQr2xDc2dA=w90-h90-p-rp-mo-br100',
  rating: 5,
  text: "Not sure where to begin because everything has been amazing with this team from the very first call! Aryan has been helping us find our first apartment in Dubai and saying he's been immensely helpful is truly not doing him justice. He has gone above and beyond for us in this process of apartment hunting. We spent several days with him and Naina touring apartments throughout Dubai and ultimately didn't find a place that truly ticked all of our boxes on that trip. BUT, Aryan did not stop looking while we had to head back home to pack and prep for our move. He ended up finding us the most perfect apartment, took an amazing video for us and included all of the things that were top priority for us like the parks around our building and such. He made sure we felt like we were there at the viewing with him! Aryan and Naina both made us feel like family and we cannot wait to move in to the amazing apartment Aryan found for us!!! Their knowledge and experience in all of the top areas no Dubai has proven to be so helpful for us. We are so glad to have gotten the opportunity to work with Aryan and Naina and would HIGHLY recommend them and their team for all of your real estate needs."
}, {
  id: 3,
  name: 'Adit Rao',
  avatar: 'https://lh3.googleusercontent.com/a-/ALV-UjXyYdeS00HQlkPcI-ZcY3xPIuPXOhtdHQgzWibc_vl9ZdGC7kFerg=w90-h90-p-rp-mo-ba4-br100',
  rating: 5,
  text: 'Ikigai has been great help finding us the right house. Constant support by Aryan and his team truly helped us find the right house and literally helped us with the moving in too. The entire process was speedy and recommend everyone to try their services. They are truly unlike those typical brokers. Kudos to Ikigai team!'
}, {
  id: 4,
  name: 'Büşra Yıldız',
  avatar: '',
  rating: 5,
  text: 'I had a great experience with Ikigai Real Estate! The team was professional, responsive, and really supportive throughout the whole process. I especially want to thank Carolin, who went above and beyond to help me. She was kind, attentive, and always available to answer my questions. Carolin made everything smooth and stress-free I truly felt like I was in good hands. I would highly recommend Ikigai Real Estate to anyone looking for a trustworthy and efficient agency in Dubai. Thank you again!'
}, {
  id: 5,
  name: 'S JL',
  avatar: '',
  rating: 5,
  text: "I recently had the pleasure of working with Ikigai Real Estate, who approached me on behalf of their client to rent out my property in Dubai Investment Park. From start to finish, Shalini and her team were exceptional—highly professional, responsive, and thorough throughout the entire process. What truly stood out was their continued involvement even after the initial agreements were signed. In an industry where many agents tend to disappear once the deposit and first payment are made, Shalini and her team went above and beyond, ensuring smooth coordination between the tenant and me on several follow-up matters. This level of dedication is rare in the rental market, and I genuinely can't think of a better team to handle such transactions. I highly recommend Ikigai Real Estate and look forward to working with them again in the future."
}, {
  id: 6,
  name: 'Arjun Bansal',
  avatar: '',
  rating: 5,
  text: 'We recently invested in a property in Dubai through Ikigai Real Estate. They supported us since the very beginning and understood our requirements at every step. They helped us narrow down to the property we love, guided us through the process and coordinated with the developer at every step. We will definitely recommend them to our family and friends.'
}, {
  id: 7,
  name: 'Ajay Kochhar',
  avatar: 'https://lh3.googleusercontent.com/a-/ALV-UjWFncLOz1VxydhlHW9tFiIFgLFAlxG4WGeEWb4FWGnKqAkDC7ln=w90-h90-p-rp-mo-br100',
  rating: 5,
  text: 'My experience of renting a Villa with Ikigai Real Estate has been smooth, transparent and without any hassle. I am more than 100% satisfied with my experience of dealing with Shalini at Ikigai. The renting process was not only smooth but the after service that we received was phenomenal. Shalini made sure that she checked each and every thing with us while the property was getting ready for our occupation. In fact, she sourced a property for us that matched our exact requirement including Vastu and a wonderful landlord. I am really more than satisfied. I will definitely refer our friends and family to Ikigai Real Estate and inspire them to work with them because for Ikigai, client comes first.'
}, {
  id: 8,
  name: 'Simran Dhingra',
  avatar: 'https://lh3.googleusercontent.com/a-/ALV-UjVxuXmvHUJ80Gm3gqAVndDzHVrJWySmJ4LaXzNKKeVEr6Mm13Nq=w90-h90-p-rp-mo-br100',
  rating: 5,
  text: "Ikigai's Naina Arora recently helped me find my dream apartment in Dubai. She understood my vision deeply and helped me find something that ticked all the boxes at a good rental cost. I look forward to working with her again once I'm ready to buy!"
}, {
  id: 9,
  name: 'M Mt',
  avatar: 'https://lh3.googleusercontent.com/a-/ALV-UjUOziO5AkJ8EuaXe9szQksnCAwgd8zWxxjwHjzs7G8wKkAp29ec=w90-h90-p-rp-mo-br100',
  rating: 5,
  text: "Before investing in Dubai's real estate market, I was concerned about market fluctuations, legal complexities, and long-term returns. I had many questions about regulations, ROI potential, and the overall investment climate. What stood out about Ikigai Real Estate was their deep market knowledge and client-focused approach. Shalini and her team patiently educated me on different opportunities, helping me make an informed decision. Their insights on market trends and investment hotspots gave me the confidence to move forward. The guidance I received was exceptional—every recommendation was backed by thorough research and real-time market data. The transaction process was smooth and transparent, with their proactive support ensuring all paperwork was handled seamlessly. I'm especially pleased with my property's prime location, strong rental yield, and overall quality—it's exactly what I was looking for. Ikigai also manages both my properties through their Property Supervision services, giving me peace of mind while I'm abroad. For anyone considering investing in Dubai's real estate, I highly recommend working with a team that prioritizes your interests. Ikigai Real Estate ensures your investment aligns with your goals while minimizing risks. I will definitely invest with them again for their expertise, integrity, and commitment."
}, {
  id: 10,
  name: 'Brijesh Zaveri',
  avatar: 'https://lh3.googleusercontent.com/a-/ALV-UjXQCeL6Ap71FshUlrWs7MOcjf0_1DrPVHTJF7oxOpwwkCmlAiU=w90-h90-p-rp-mo-ba3-br100',
  rating: 5,
  text: "Nelson is an exceptional professional with in-depth expertise in Dubai's real estate market. His extensive knowledge spans residential, commercial, and investment properties, making him a go-to expert for buyers, sellers, and investors. With a keen understanding of market trends, property valuation, and legal regulations, Nelson provides strategic insights to help clients make informed decisions. His personalized approach, strong negotiation skills, and commitment to client success set him apart in the industry."
}];
const CHAR_LIMIT = 300;
const TestimonialCard = ({
  testimonial,
  colorIndex,
  isExpanded,
  onToggleExpand
}: {
  testimonial: Testimonial;
  colorIndex: number;
  isExpanded: boolean;
  onToggleExpand: () => void;
}) => {
  const shouldTruncate = testimonial.text.length > CHAR_LIMIT;
  const displayText = shouldTruncate && !isExpanded ? testimonial.text.slice(0, CHAR_LIMIT) + '...' : testimonial.text;
  return <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col h-full" data-id="element-444">
      {/* Stars */}
      <div className="flex items-center gap-1 mb-4" data-id="element-445">
        {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-[#d8a34d] fill-[#d8a34d]" data-id="element-446" />)}
      </div>

      {/* Review Text */}
      <p className="text-gray-700 text-sm leading-relaxed mb-6 flex-grow" data-id="element-447">
        "{displayText}"
        {shouldTruncate && <button onClick={onToggleExpand} className="ml-1.5 text-[#d8a34d] font-semibold hover:text-[#c4922f] transition-colors text-sm" data-id="element-448">
            {isExpanded ? 'Read less' : 'Read more'}
          </button>}
      </p>

      {/* Author Info with Avatar */}
      <div className="border-t border-gray-100 pt-4 flex items-center gap-3 mt-auto" data-id="element-449">
        {testimonial.avatar ? <img src={testimonial.avatar} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover flex-shrink-0" referrerPolicy="no-referrer" data-id="element-450" /> : <div className={`w-10 h-10 rounded-full ${AVATAR_COLORS[colorIndex % AVATAR_COLORS.length]} flex items-center justify-center flex-shrink-0`} data-id="element-451">
            <span className="text-white font-bold text-xs" data-id="element-452">
              {getInitials(testimonial.name)}
            </span>
          </div>}
        <p className="font-display font-bold text-[#1a2e1c] text-sm leading-tight" data-id="element-453">
          {testimonial.name}
        </p>
      </div>
    </div>;
};
export const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [expandedIds, setExpandedIds] = useState<Set<number>>(new Set());
  const [isPaused, setIsPaused] = useState(false);
  const next = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  }, []);
  const prev = useCallback(() => {
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  }, []);
  const toggleExpanded = (id: number) => {
    setExpandedIds(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };
  // Auto-advance every 6 seconds
  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  }, [isPaused, next]);
  // Get 3 visible testimonials (wrapping around)
  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < 2; i++) {
      const idx = (currentIndex + i) % testimonials.length;
      visible.push({
        testimonial: testimonials[idx],
        originalIndex: idx
      });
    }
    return visible;
  };
  const visibleCards = getVisibleTestimonials();
  return <section className="bg-gray-50 pt-8 md:pt-14 pb-8 md:pb-16 relative overflow-hidden" data-id="element-454">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-[#d8a34d] opacity-[0.03] rounded-full blur-3xl pointer-events-none -translate-x-1/3 -translate-y-1/3" data-id="element-455"></div>

      <div className="container mx-auto px-4 md:px-8" data-id="element-456">
        <div className="max-w-6xl mx-auto" data-id="element-457">
          {/* Header */}
          <div className="text-center mb-6 md:mb-8" data-id="element-458">
            <span className="text-[#d8a34d] text-xs md:text-sm font-semibold tracking-[0.2em] uppercase mb-4 block" data-id="element-459">
              Client Reviews
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-[#1a1a1a] leading-tight" data-id="element-460">
              What Our Clients Say
            </h2>
          </div>

          {/* Slider */}
          <div className="relative" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-461">
            {/* Navigation Arrows */}
            <button onClick={prev} className="absolute -left-2 md:-left-6 top-1/2 -translate-y-1/2 z-10 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center text-[#1a2e1c] hover:bg-gray-50 transition-colors shadow-md" aria-label="Previous testimonial" data-id="element-462">
              <ChevronLeftIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-463" />
            </button>
            <button onClick={next} className="absolute -right-2 md:-right-6 top-1/2 -translate-y-1/2 z-10 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center text-[#1a2e1c] hover:bg-gray-50 transition-colors shadow-md" aria-label="Next testimonial" data-id="element-464">
              <ChevronRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-465" />
            </button>

            {/* Cards Grid — 1 on mobile, 3 on desktop */}
            <div className="mx-6 md:mx-8" data-id="element-466">
              {/* Mobile: show only first visible card */}
              <div className="block lg:hidden" data-id="element-467">
                <TestimonialCard testimonial={visibleCards[0].testimonial} colorIndex={visibleCards[0].originalIndex} isExpanded={expandedIds.has(visibleCards[0].testimonial.id)} onToggleExpand={() => toggleExpanded(visibleCards[0].testimonial.id)} data-id="element-468" />
              </div>

              {/* Desktop: show 3 cards */}
              <div className="hidden lg:grid lg:grid-cols-2 gap-6" data-id="element-469">
                {visibleCards.map(({
                testimonial,
                originalIndex
              }) => <TestimonialCard key={`${currentIndex}-${testimonial.id}`} testimonial={testimonial} colorIndex={originalIndex} isExpanded={expandedIds.has(testimonial.id)} onToggleExpand={() => toggleExpanded(testimonial.id)} data-id="element-470" />)}
              </div>
            </div>

            {/* Dots */}
            <div className="flex items-center justify-center gap-2 mt-5" data-id="element-471">
              {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 rounded-full transition-all duration-300 ${index === currentIndex ? 'bg-[#d8a34d] w-8' : 'bg-gray-300 w-2 hover:bg-gray-400'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-472" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};